import { Component, OnInit, Inject, QueryList, ViewChildren } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { StoreService } from '@app/feature/store-admin/services/store.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StorePublishModel } from '@app/shared/models/storepublish';
import { Router } from '@angular/router';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { ProductService } from '@app/shared/services/product/product.service';

import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-publish-product',
  templateUrl: './publish-product.component.html',
  styleUrls: ['./publish-product.component.css']
})
export class PublishProductComponent implements OnInit {

  customizedProductId: any;
  warehouseProductId: any;
  ApplicationUserId !: any;
  storeList !: any[];
  pushToShopify = false;
  isCheckboxShopifyEnabled = true;
  DesignId = 0;
  ProductId = 0;
  storeForm: FormGroup;
  storePublishModel !: StorePublishModel;
  @ViewChildren('publishCheckbox') private publishCheckboxes !: QueryList<any>;
  selectedStores: any[] = [];

  constructor(public dialogRef: MatDialogRef<PublishProductComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private storeService: StoreService, private notificationService: NotificationService,
    private fb: FormBuilder, private router: Router, private errorhandlerService: ErrorhandlerService,
    private productService: ProductService, private http: HttpClient) {
    this.storeForm = this.fb.group({
      selectedStore: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.customizedProductId = this.data.IsWareHouseProduct ? 0 : this.data.CustomizedProductId;
    this.warehouseProductId = this.data.IsWareHouseProduct ? this.data.WarehouseProductId : 0;
    this.DesignId = this.data.DesignId;
    this.ProductId = this.data.ProductId;
    this.ApplicationUserId = localStorage.getItem('userId');
    this.fn_getStoreList();
  }

  onclose(): void {
    this.dialogRef.close();
  }

  /** Function to get store list */
  fn_getStoreList() {

    try {
      this.loaderService.show();
      this.storeService.GetStoresForProductPublish(this.ApplicationUserId, this.customizedProductId, this.warehouseProductId).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          //this.storeList = res.Data.ResponseData.filter((store) => {
          //  return store.apikey == null;// exclude shopify stores
          //});
          this.storeList = res.Data.ResponseData;
        } else if (res.StatusCode === 204) {
        }
        this.loaderService.hide();
      }, err => {
        this.loaderService.hide();
        this.notificationService.error('An error occured', 'Error');
      });
    } catch (error) {
      this.loaderService.hide();
      this.errorhandlerService.handleError(error);
    }
  }
  //enablingShopifyCheckbox(form: FormGroup) {
  //  const stores = this.storeList.filter((store) => {
  //    return store.apikey != null && form.value.selectedStore.indexOf(store.StoreId) !== -1;
  //  });
  //  this.isCheckboxShopifyEnabled = stores.length === 0;
  //  return stores;
  //}
  /** Function to publish products on store
   * @param form Form post data.
  */
  fn_publish(form: FormGroup) {
    //if (this.pushToShopify) {
     // this.productService.getCustomizedProductDetailsByProductId(this.ProductId, this.DesignId, form.value.selectedStore).subscribe((res: any) => {
        //No longer interewted in publishing these product to the shopfy store
        //this.enablingShopifyCheckbox(form).forEach((store) => {
        //  if (res.Data.ResponseData[0] && res.Data.ResponseData[0].StoreId === null) {
        //    res.Data.ResponseData[0].StoreId = store.StoreId;
        //  }
        //  this.http.post<any>(environment.baseUrlShopifyApp + '/api/product/raw', res, {
        //    headers: {
        //      'x-api-key': store.apikey
        //    }
        //  }).subscribe((data) => {
        //    console.log(data);
        //  });
        //});
     // });
    //}
    this.loaderService.show();
    this.storePublishModel = {
      CustomizedProductId: this.customizedProductId,
      StoreAdminId: this.ApplicationUserId,
      StoreId: form.value.selectedStore,
      WarehouseProductId: this.warehouseProductId
    };
    this.storeService.saveStorePublishProducts(this.storePublishModel).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Product Published Successfully.');
        this.dialogRef.close();
        this.loaderService.hide();
        this.router.navigate(['/store/publishedproducts']);
      } else if (res.StatusCode === 203) {
        this.notificationService.info(res.Message, 'Published Product');
        // this.dialogRef.close();
        this.loaderService.hide();
      }
      this.loaderService.hide();
    }, (err: any) => {
      this.loaderService.hide();
      this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
    });
  }

  /**  */
  fn_SelectPublishProducts(event: any, storeId: string, form: FormGroup) {
    if (this.selectedStores.length > 0) {
      for (let i = 0; i < this.selectedStores.length; i++) {
        if (this.selectedStores[i] === storeId && !event.checked) {
          this.selectedStores.splice(i, 1);
        }
      }
    }
    if (event.checked) {
      this.selectedStores.push(storeId);
    }

    this.storeForm.setValue({
      selectedStore: this.selectedStores
    });
    //this.enablingShopifyCheckbox(form);
  }
}
